"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";

// * ─── FAQ Section ────────────────────────────────────────────────────────────
export function HomeFaqSection() {
  const { t } = useTranslation("common");

  const faqs = t("homeFaq.questions", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-4">
            {t("homeFaq.title")}
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300">
            {t("homeFaq.subtitle")}
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <GlassCard key={index} className="p-6">
              <details className="group">
                <summary className="flex items-center justify-between cursor-pointer list-none">
                  <h3 className="text-lg font-semibold text-walnut-900 dark:text-white">
                    {faq.question}
                  </h3>
                  <span className="transition group-open:rotate-180">
                    <svg
                      fill="none"
                      height="24"
                      shapeRendering="geometricPrecision"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      width="24"
                      className="text-walnut-700 dark:text-walnut-300"
                    >
                      <path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </span>
                </summary>
                <p className="text-walnut-700 dark:text-walnut-300 mt-4 leading-relaxed">
                  {faq.answer}
                </p>
              </details>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
}
